import { render, staticRenderFns } from "./msgtypeChatrecord.vue?vue&type=template&id=216be5d4&scoped=true&"
import script from "./msgtypeChatrecord.vue?vue&type=script&lang=js&"
export * from "./msgtypeChatrecord.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeChatrecord.vue?vue&type=style&index=0&id=216be5d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216be5d4",
  null
  
)

export default component.exports